import { GROUP_TEAMS } from '~/consts'

export const state = () => ({
  groupMembers: [],
  suggestions: [],
  groupTeamMaxOrder: 0,
  groupTeamsData: [],
  countMembersPerTeamOptionSelected: '',
  minMembersPerTeam: 0,
  selectedGroupTeamOrder: 0,
  createFeedbackShow: false,
  cancelCreateShow: false,
})

export const mutations = {
  setGroupMembers(state, members) {
    state.groupMembers = members
  },
  setSuggestions(state, suggestions) {
    state.suggestions = suggestions
  },
  setGroupTeamMaxOrder(state, order) {
    state.groupTeamMaxOrder = order
  },
  setGroupTeamsData(state, teams) {
    state.groupTeamsData = teams
  },
  setCountMembersPerTeamOptionSelected(state, selected) {
    state.countMembersPerTeamOptionSelected = selected
  },
  setMinMembersPerTeam(state, teams) {
    state.minMembersPerTeam = teams
  },
  setSelectedGroupTeamOrder(state, order) {
    state.selectedGroupTeamOrder = order
  },
  setCreateFeedback(state, shown) {
    state.createFeedbackShow = shown
  },
  setCancelCreate(state, shown) {
    state.cancelCreateShow = shown
  },
}

export const actions = {
  async getGroupMembers({ commit }, groupId) {
    try {
      const { data } = await this.$axios.post(GROUP_TEAMS.GET_GROUP_MEMBERS, { group_id: groupId })

      commit('setGroupMembers', [])
      if (data.applicationSystem.code == 0) {
        commit('setGroupMembers', data.data)
      }
    } catch (error) {
      commit('setGroupMembers', [])
    }
  },

  async getSuggestions({ commit }, groupId) {
    try {
      const { data } = await this.$axios.post(GROUP_TEAMS.GET_SUGGESTIONS, { group_id: groupId })

      commit('setSuggestions', [])
      if (data.applicationSystem.code == 0) {
        commit('setSuggestions', data.data.createGroupSuggestions)
        commit('setGroupTeamMaxOrder', data.data.groupTeamMaxOrder)
      }
    } catch (error) {
      commit('setSuggestions', [])
    }
  }
}
